import { useState } from 'react'
import { Formik } from 'formik'
import classnames from 'classnames/bind'
import { useCustomEventListener } from 'react-custom-events'
import { ViewStepper, CurrentView, ResetButton } from '~/components'
import { default as SelectMethod } from '~/components/OtpFlow/SelectMethod'
import { default as ValidatePhone } from '~/components/OtpFlow/ValidatePhone'
import { default as InputEmail } from '~/components/OtpFlow/InputEmail'
import { default as ValidateEmail } from '~/components/OtpFlow/ValidateEmail'
import { default as InputName } from '~/components/OtpFlow/InputName'
import { default as AcceptTerms } from '~/components/OtpFlow/AcceptTerms'
import { default as SocialAddPhone } from '~/components/OtpFlow/SocialAddPhone'
import { default as SocialValidatePhone } from '~/components/OtpFlow/SocialValidatePhone'
import { default as ConfirmExistingProfile } from '~/components/OtpFlow/ConfirmExistingProfile'
import { default as SocialSelectEmail } from '~/components/OtpFlow/SocialSelectEmail'
import * as styles from './index.module.css'
import { useTranslation } from 'react-i18next'

const cx = classnames.bind(styles)

export default function LoginModule() {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const [completeCallback, setCompleteCallback] = useState(null)
  const [startView, setStartView] = useState(null)

  const views = [
    { id: 'selectMethod', component: SelectMethod },
    { id: 'validatePhone', component: ValidatePhone },
    { id: 'inputEmail', component: InputEmail },
    { id: 'validateEmail', component: ValidateEmail },
    { id: 'inputName', component: InputName },
    { id: 'acceptTerms', component: AcceptTerms, props: { isLogin: true } },
    { id: 'socialAddPhone', component: SocialAddPhone },
    { id: 'socialValidatePhone', component: SocialValidatePhone },
    { id: 'confirmExistingProfile', component: ConfirmExistingProfile },
    { id: 'socialSelectEmail', component: SocialSelectEmail },
  ]

  const initialValues = {
    dialCode: '+46',
    phone: '',
    phoneCode: '',
    email: '',
    maskedEmail: '',
    emailCode: '',
    firstName: '',
    lastName: '',
    marketingOptIn: false,
    termsAndConditions: false,
    shouldConsentToMarketing: true,
    shouldConsentToTermsAndConditions: true,
    externalEmail: '',
    existingUserName: '',
    existingUserEmail: '',
  }

  useCustomEventListener(
    'SHOW_LOGIN',
    (data) => {
      const show = data === null || data?.show === true
      if (show && data?.callback) {
        setCompleteCallback(() => data.callback)
      } else {
        setCompleteCallback(null)
      }
      if (show && data?.startView) {
        setStartView(data.startView)
      } else {
        setStartView(null)
      }
      setIsOpen(show)
    },
    [isOpen]
  )

  return (
    <div className={cx(styles.overlay, { isOpen })}>
      {isOpen && <div className={styles.wrapper}>
        <ViewStepper views={views} complete={completeCallback} initialView={startView} onBack={() => setIsOpen(false)}>
          {({ View }) => {
            return (
              <Formik
                initialValues={initialValues}
                validationSchema={View?.validationSchema || null}
                onReset={() => {
                  setIsOpen(false)
                }}
              >
                <>
                  <CurrentView />
                  <ResetButton message={t('reset-login-message')} />
                </>
              </Formik>
            )
          }}
        </ViewStepper>
      </div>}
    </div>
  )
}
